import { render, staticRenderFns } from "./FundCard.vue?vue&type=template&id=52aecad4&scoped=true"
import script from "./FundCard.vue?vue&type=script&lang=js"
export * from "./FundCard.vue?vue&type=script&lang=js"
import style0 from "./FundCard.vue?vue&type=style&index=0&id=52aecad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aecad4",
  null
  
)

export default component.exports